import React from 'react';
import {Props} from './Props';
import {css} from 'aphrodite';
import styles from './styles';

const BEARING_ICON_COMPENSATION_DEGREES = 45;

const BearingCompass: React.FunctionComponent<Props> = ({bearing}) => {
    const label = `${bearing} graden`;
    return (
        <span aria-label={label} title={label} className={css(styles.bearingIcon)}>
            <span
                className="fas fa-location-arrow"
                style={{
                    transform: `rotate(${bearing - BEARING_ICON_COMPENSATION_DEGREES}deg)`,
                }}
            />
        </span>
    );
};

export default BearingCompass;
